import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex flex-col overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20streetwear%20fashion%20moodboard%20with%20overlapping%20textures%20fabric%20swatches%20in%20warm%20cream%20beige%20sand%20tones%20sneaker%20silhouette%20sketches%20soft%20geometric%20abstract%20shapes%20elegant%20editorial%20collage%20style%20soft%20diffused%20lighting%20no%20text%20warm%20neutral%20color%20palette%20with%20subtle%20olive%20accents%20sophisticated%20minimalist%20aesthetic%20with%20generous%20negative%20space%20museum%20quality%20composition&width=1800&height=1200&seq=hero-bg-hoobuy-v3&orientation=landscape"
          alt="Streetwear fashion collage - Planilha Hoobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
      </div>

      <div className="relative z-10 flex-1 flex flex-col justify-center w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-28">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16 w-full max-w-[1400px] mx-auto">
          <div className="w-full lg:w-[60%]">
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-background-50 leading-[1.05] tracking-tight">
              {t("hero.h1_line1")}
              <br />
              <span className="text-primary-300">{t("hero.h1_line2")}</span>
              <br />
              {t("hero.h1_line3")}
            </h1>
          </div>

          <div className="w-full lg:w-[40%] flex flex-col justify-end gap-6 pt-4 lg:pt-8">
            <p className="text-base md:text-lg text-background-50/85 leading-relaxed max-w-md font-body font-light">
              {t("hero.subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold text-background-50 border-2 border-background-50/80 rounded-full hover:bg-background-50 hover:text-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                {t("hero.cta_sheet")}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold text-foreground-950 bg-background-50 rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line"></i>
                {t("hero.cta_buy")}
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-3 mt-12 md:mt-16 pb-8 max-w-[1400px] mx-auto w-full">
          {[
            { icon: "ri-checkbox-circle-line", text: "10.000+ Produtos" },
            { icon: "ri-refresh-line", text: "Links Atualizados" },
            { icon: "ri-shield-check-line", text: "Compra Segura" },
            { icon: "ri-global-line", text: "Guias em Português" },
            { icon: "ri-eye-line", text: "Verificação Manual" },
          ].map((item, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full text-xs md:text-sm text-background-50 font-medium whitespace-nowrap"
            >
              <i className={item.icon}></i>
              {item.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}